export default __webpack_public_path__ + "static/media/getting_started_team.8787cfda.png";